// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { A11y, Autoplay } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';
import './_testimonial.scss';

// -------------------------------------
// Hooks
// -------------------------------------
function handleTestimonialSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= $(window).height() &&
            slidePos.right <= $(window).width())) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - ($(window).height() / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }

        })
    });
}


$(function() {
    $(".carousel--testimonials").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("testimonials-instance-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".testimonials-instance-" + index, {
            // Optional parameters
            modules: [A11y, Autoplay],
            slidesPerView: 1.3,
            spaceBetween: 30,
            centerInsufficientSlides: true,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            grabCursor: true,
            freeMode: true,
            loop: true,
            autoplay: {
                delay: 0,
                pauseOnMouseEnter: false,
                disableOnInteraction: false
            },
            speed: 10000,
            breakpoints: {
                680: {
                    slidesPerView: 2.4,
                    spaceBetween: 50,
                },
                1024: {
                    slidesPerView: 3.5
                },
                1366: {
                    slidesPerView: 4.5,
                }
            }
        });

        if (swiper.slides) {
            handleTestimonialSlides(swiper);
        } else {
            swiper.forEach(function(swiperEl) {
                handleTestimonialSlides(swiperEl);
            })
        }

        swiper.on('touchMove', function(e){
            swiper.autoplay.stop();
            swiper.params.speed = 200;
        })
    });
});
